import { showProgramSummaryInfo } from './utils';
import { getProgramById } from '../../products/common/services/program-service';
import { modalUtils } from '@/app/core/utils';
import history from '@/app/core/history';
import { Job } from '@ssar-app/domain';
import { Icon, Link, Tooltip } from '@chakra-ui/react';
import { AiOutlineInfoCircle } from 'react-icons/ai/index.js';
import { Link as ReactRouterLink } from 'react-router-dom';
import { usePathContext } from '@ssar-app/okta-authn-react';

interface ButtonProps {
  record: Job;
  setIsLoading: (arg0: boolean) => void;
  forJobs: boolean;
}

export const JobsInfoButton = (props: ButtonProps) => {
  const { record, setIsLoading, forJobs } = props;
  const { buildPath } = usePathContext();
  const showProgramSummary = async () => {
    await getProgramById(record.programId)
      .then((a) => {
        setIsLoading(false);
        if (a.resultCode !== 0) {
          modalUtils.showError(a, 'Error while fetching program.');
        } else {
          showProgramSummaryInfo(
            a.data?.data,
            record.programId,
            a.data?.dataDictionaryVersion || '',
            false,
            buildPath,
            '',
            history,
          );
        }
      })
      .catch((err) => {
        modalUtils.showError(err, 'Error while fetching the Program details');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Tooltip
      placement='left'
      label={`Show ${
        forJobs || record?.isAps ? 'program' : 'template'
      } details`}
      hasArrow
    >
      <Link
        as={ReactRouterLink}
        to={buildPath(`/show-program-details?productName=${record.system}`)}
        onClick={(e) => {
          e.preventDefault();
          setIsLoading(true);
          showProgramSummary();
        }}
        _hover={{
          textDecoration: 'unset',
        }}
        _focus={{ boxShadow: 'none' }}
      >
        <Icon
          as={AiOutlineInfoCircle}
          color={!forJobs ? { color: '#1d4f91' } : {}}
          sx={{ fontSize: 'md', mb: -1 }}
        />

        {forJobs && ' Program Info'}
      </Link>
    </Tooltip>
  );
};
